module.exports = __webpack_public_path__ + "media/images/shared/logo_savorjapan-e47356ff85dcb726f3d00e4f2dbcdab5.png";